import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6">
        <h2 className="font-heading text-xl md:text-2xl text-foreground-900">分类导航</h2>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 md:gap-5">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group relative bg-background-100 hover:bg-primary-50 rounded-xl p-5 md:p-6 flex flex-col items-center gap-3 transition-all duration-300 hover:scale-105 cursor-pointer"
          >
            <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
              <i className={`${cat.icon} text-xl md:text-2xl text-primary-600`}></i>
            </div>
            <span className="text-sm md:text-base font-semibold text-foreground-800 group-hover:text-primary-700 transition-colors whitespace-nowrap">
              {cat.name}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}